export const getters = {
  aviss(state) {
    return state.aviss;
  },
  avis(state) {
    return state.avis;
  },
  pagination(state) {
    return state.pagination;
  },
};
